/** Derive an editable catalog code from a display name (e.g. "2x6 Joist Upgrade" → "2X6_JOIST_UPGRADE"). */
export function namedVariantCodeFromName(name: string): string {
  return name
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 64);
}
